import React, { Component } from 'react';
import {connect} from "react-redux";
import uuidv4 from 'uuid/v4';
import ContainerDimensions from "react-container-dimensions";
import {Group, Layer, Stage, Text, TextPath, Transformer} from "react-konva";
import CachedImage from "../CachedImage";
import {Button} from "reactstrap";
// import TemplateLayouts from "./TemplateLayouts";
import {
  setPhase,
  setFaceObjects,
  closeTour,
  setTextValue,
  setTextFont,
  setTextColor,
  toggleLoading,
  showCopyrightModal,
  deselectObjects, transformObject, moveObject, deleteObject, updateObjectSizes, selectObject,
  editObject,
  setExtraTextValue, setExtraTextFont, setExtraTextColor, addFaceExtraItem, addNewImage,
  setTextSize, setExtraTextSize
} from "../../actions";
import Tour from "reactour";
import ChoiceWidget from "../ChoiceWidget";
import {SimpleColorPicker} from "../ColorPicker";
import _forEach from "lodash/forEach";
import CanvasLayer from "../CanvasLayer";
import SvgSticker from "../SvgSticker";
import {DragDrop} from "@uppy/react";
import Uppy from "@uppy/core";
import XHRUpload from "@uppy/xhr-upload";
import KeyHandler from "react-key-handler";
import _filter from 'lodash/filter';
import CurvedArrow from "../CurvedArrow";

class TemplateFreeLayoutStage extends Component {
  groupTransformer = null;
  group = null;
  sizeRef = {};

  constructor(props) {
    super(props);
    // this.handleBack = this.handleBack.bind(this);
    // this.renderCheckoutButton = this.renderCheckoutButton.bind(this);
    this.handleStageClick = this.handleStageClick.bind(this);
    this.handleTransform = this.handleTransform.bind(this);
    //this.handleMultipleTransform = this.handleMultipleTransform.bind(this);
    this.handleMoveHOC = this.handleMoveHOC.bind(this);
    //this.handleStickerMoveHOC = this.handleStickerMoveHOC.bind(this);
    this.handleDeleteKeyDown = this.handleDeleteKeyDown.bind(this);
    this.renderText = this.renderText.bind(this);
    this.renderImage = this.renderImage.bind(this);
    this.renderSticker = this.renderSticker.bind(this);
    this.showBoundingBox = this.showBoundingBox.bind(this);
    this.hideBoundingBox = this.hideBoundingBox.bind(this);
    this.updateObjectSizes = this.updateObjectSizes.bind(this);
    //this.renderGrids = this.renderGrids.bind(this);
    this.handleCopy = this.handleCopy.bind(this);
    this.renderTransformer = this.renderTransformer.bind(this);
    this.handleKeyMoveHOC = this.handleKeyMoveHOC.bind(this);
  }

  UNSAFE_componentWillReceiveProps(newProps, oldProps) {
    if (newProps.layers.selected.length > 1) {
      this.showBoundingBox(newProps.layers.selected);
    } else {
      this.hideBoundingBox();
    }
  }

  componentDidMount() {
    console.log(this.cdRef);
    if (this.props.layers.selected.length > 1) {
      this.showBoundingBox(this.props.layers.selected);
    } else {
      this.hideBoundingBox();
    }

    console.log(this.groupTransformer, this.group);
    this.updateObjectSizes();
  }

  handleStageClick(e) {
    //console.log(e);
    this.props.deselectObjects();
    this.props.closeTour(6);
  }

  handleTransform(e) {
    console.log(e);
    this.props.transformObject(e.currentTarget.attrs);
  }

  handleMoveHOC(id) {
    return (e) => {
      console.log(e);
      if (e.target.className === 'Transformer') {
        console.log('This is transformer. Skipped.');
        return;
      }

      this.props.moveObject(id, e.target.attrs.x, e.target.attrs.y);
    };
  }

  handleKeyMoveHOC(payload) {
    return (e) => {
      if (this.props.layers.selected.length !== 1) {
        return;
      }

      const surfaceId = this.props.objects.present.currentSurface.surface.id;
      const object = this.props.objects.present.objects[surfaceId][this.props.layers.selected[0]];

      this.props.moveObject(object.id, object.props.x + payload.x, object.props.y + payload.y);

      //console.log(e);
      if (e.keyCode === 38 || e.keyCode === 40) {
        console.log('UP/DOWN key is ignored');
        e.preventDefault();
      }
    };
  }

  handleDeleteKeyDown(e) {
    e.preventDefault();
    if (this.props.layers.selected.length > 0) {
      this.props.deleteObject(this.props.layers.selected);
    }
    e.stopPropagation();
  }

  handleCopy(e) {
    console.log(e);
  }


  render() {
    const height = this.props.height;
    const paperX = 550;
    const paperY = 910;
    //const ratio  = paperY / paperX;
    const sizeRatio = (height - 50) / paperY;

    const canvasHeight = paperY * sizeRatio;
    const canvasWidth = paperX * sizeRatio;
    const imageRatio = this.props.meishi.croppedImage.width / this.props.meishi.croppedImage.height;
    const imageProps = {
      id: 'face',
      ...this.props.meishi.finalImage,
      props: {
        width: canvasWidth,
        height: canvasWidth / imageRatio,
        x: this.props.meishi.finalImage.x * sizeRatio,
        y: this.props.meishi.finalImage.y * sizeRatio - canvasHeight * 0.1,
        scaleX: this.props.meishi.finalImage.scaleX,
        scaleY: this.props.meishi.finalImage.scaleY,
      }
    }
    this.sizeRef = {
      canvasWidth, canvasHeight, sizeRatio
    };

    const currentLayout = this.props.meishi.layouts[this.props.meishi.currentLayout];
    const currentSurface = this.props.objects.present.currentSurface;
    const surfaceId = this.props.objects.present.currentSurface.surface.id;
    const objects = this.props.objects.present.objects[surfaceId];
    const index = this.props.objects.present.index[surfaceId];

    return (
      <Stage width={canvasWidth} height={canvasHeight} onClick={this.handleStageClick} style={{backgroundColor: "#ffffff"}}>
        <Layer listening={false}>
          <CachedImage listening={false} inline={true} name={'face'} src={this.props.meishi.finalImage.src} props={imageProps.props} />
          {/*{this.renderGuide(canvas, this.props.products.currentColor.border_color)}*/}
        </Layer>

        <Layer x={0} y={0} clip={{x: canvasWidth * 0.05, y: 0, width: canvasWidth * 0.9, height: canvasHeight}}>
          {index.map(id => {
            return this.renderObject(objects[id]);
          })}
        </Layer>
        <Layer>
          <Group x={0} y={0}>
            <Group x={0} y={0} ref={node => {this.group = node;}} draggable={true} name='temporaryGroup' onTransformEnd={this.handleMultipleTransform}/>
            <Transformer
              ref={node => {this.groupTransformer = node;}}
              draggable={true}
            />
          </Group>
          {index.map(id => {
            return this.renderTransformer(objects[id]);
          })}
        </Layer>
      </Stage>
    );
  }

  renderTransformer(object) {
    const anchorConfig = {
      full: ['top-left', 'top-center', 'top-right', 'middle-right', 'middle-left', 'bottom-left', 'bottom-center', 'bottom-right'],
      keepRatio: ['top-left', 'top-right', 'bottom-left', 'bottom-right']
    };

    let rotatable = true;
    if (object && typeof object.rotateEnabled !== 'undefined') {
      rotatable = object.rotateEnabled;
    }

    let resizable = true;
    if (object && typeof object.resizeEnabled !== 'undefined') {
      resizable = object.resizeEnabled;
    }

    let anchors = anchorConfig.full;
    if (object && typeof object.keepRatio !== 'undefined') {
      anchors = anchorConfig[object.keepRatio ? 'keepRatio' : 'full'];
    }

    return (
      <Transformer
        id={"global-transformer-" + object.id}
        key={"global-transformer-" + object.id}
        draggable={true}
        keepRatio={true}
        rotateEnabled={rotatable}
        resizeEnabled={resizable}
        enabledAnchors={anchors}
      />
    );
  }

  /**
   * General object renderer
   * @param object
   */
  renderObject(object) {
    switch (object.type) {
      case 'text':
        if (object.props.data) {
          return this.renderTextPath(object);
        } else {
          return this.renderText(object);
        }
      case 'image':
        return this.renderImage(object);
      case 'sticker':
        return this.renderSticker(object);
      case 'group':
        return this.renderGroup(object);
      default:
        return null;
    }
  }

  renderText(object) {
    return (
      <CanvasLayer key={object.id} id={object.id} type="text" object={object}>
        <Text name={object.id} {...object.props} draggable={true} onTransformEnd={this.handleTransform} onDragEnd={this.handleMoveHOC(object.id)} />
      </CanvasLayer>
    );
  }

  renderTextPath(object) {
    return (
      <CanvasLayer key={object.id} id={object.id} type="text" object={object}>
        <TextPath name={object.id} {...object.props} draggable={true} onTransformEnd={this.handleTransform} onDragEnd={this.handleMoveHOC(object.id)}  />
      </CanvasLayer>
    );
  }

  renderImage(object) {
    return (
      <CanvasLayer key={object.id} id={object.id} type="image" object={object}>
        <CachedImage name={object.id} src={object.src} props={object.props} draggable={true} onTransformEnd={this.handleTransform} onDragEnd={this.handleMoveHOC(object.id)} />
      </CanvasLayer>
    );
  }

  renderSticker(object) {
    if (object.src.match(/.svg$/)) {
      return (
        <CanvasLayer key={object.id} id={object.id} type="sticker" object={object}>
          {/*<Path name={object.id} data="m456 303.789062h-24v-104c0-13.257812-10.746094-24-24-24h-56v-72c0-4.417968-3.582031-8-8-8h-32c-4.417969 0-8 3.582032-8 8v72h-40v-72c0-4.417968-3.582031-8-8-8h-32c-4.417969 0-8 3.582032-8 8v72h-40v-72c0-4.417968-3.582031-8-8-8h-32c-4.417969 0-8 3.582032-8 8v72h-56c-13.253906 0-24 10.742188-24 24v104h-24c-13.253906 0-24 10.742188-24 24v128c0 13.253907 10.746094 24 24 24h432c13.253906 0 24-10.746093 24-24v-128c0-13.257812-10.746094-24-24-24zm8 24v5.160157c-7.832031 8.886719-19.933594 12.71875-31.453125 9.960937-11.523437-2.753906-20.578125-11.652344-23.539063-23.121094h46.992188c4.417969 0 8 3.582032 8 8zm-56-136c4.417969 0 8 3.582032 8 8v11.742188c-4.859375 2.8125-10.382812 4.28125-16 4.257812-14.585938-.019531-27.324219-9.882812-30.992188-24zm-88-80h16v64h-16zm30.992188 80c-3.636719 14.144532-16.386719 24.03125-30.992188 24.03125s-27.355469-9.886718-30.992188-24.03125zm-118.992188-80h16v64h-16zm38.992188 80c-3.636719 14.144532-16.386719 24.03125-30.992188 24.03125s-27.355469-9.886718-30.992188-24.03125zm-80 0c-3.636719 14.144532-16.386719 24.03125-30.992188 24.03125s-27.355469-9.886718-30.992188-24.03125zm-46.992188-80h16v64h-16zm-80 88c0-4.417968 3.582031-8 8-8h38.992188c-3.667969 14.117188-16.40625 23.980469-30.992188 24-5.617188.023438-11.140625-1.445312-16-4.257812zm0 29.230469c20.757812 7.386719 43.875-.355469 56-18.75 8.875 13.433594 23.898438 21.515625 40 21.515625s31.125-8.082031 40-21.515625c8.875 13.433594 23.898438 21.515625 40 21.515625s31.125-8.082031 40-21.515625c8.875 13.433594 23.898438 21.515625 40 21.515625s31.125-8.082031 40-21.515625c12.125 18.394531 35.242188 26.136719 56 18.75v74.769531h-352zm326.992188 90.769531c-3.636719 14.144532-16.386719 24.03125-30.992188 24.03125s-27.355469-9.886718-30.992188-24.03125zm-80 0c-3.636719 14.144532-16.386719 24.03125-30.992188 24.03125s-27.355469-9.886718-30.992188-24.03125zm-80 0c-3.636719 14.144532-16.386719 24.03125-30.992188 24.03125s-27.355469-9.886718-30.992188-24.03125zm-80 0c-3.636719 14.144532-16.386719 24.03125-30.992188 24.03125s-27.355469-9.886718-30.992188-24.03125zm-134.992188 8c0-4.417968 3.582031-8 8-8h46.992188c-2.960938 11.46875-12.015626 20.367188-23.539063 23.121094-11.519531 2.757813-23.621094-1.074218-31.453125-9.960937zm440 136h-432c-4.417969 0-8-3.582031-8-8v-102.5625c21.910156 12.863282 50.058594 6.285157 64-14.957031 8.875 13.433594 23.898438 21.515625 40 21.515625s31.125-8.082031 40-21.515625c8.875 13.433594 23.898438 21.515625 40 21.515625s31.125-8.082031 40-21.515625c8.875 13.433594 23.898438 21.515625 40 21.515625s31.125-8.082031 40-21.515625c8.875 13.433594 23.898438 21.515625 40 21.515625s31.125-8.082031 40-21.515625c13.941406 21.242188 42.089844 27.820313 64 14.957031v102.5625c0 4.417969-3.582031 8-8 8zm0 0,m240 87.789062c17.671875 0 32-14.328124 32-32 0-14.992187-21.167969-46.402343-25.414062-52.546874-1.574219-2.042969-4.007813-3.242188-6.585938-3.242188s-5.011719 1.199219-6.585938 3.242188c-4.246093 6.144531-25.414062 37.554687-25.414062 52.546874 0 17.671876 14.328125 32 32 32zm0-65.433593c8.535156 13.601562 16 28.128906 16 33.433593 0 8.835938-7.164062 16-16 16s-16-7.164062-16-16c0-5.296874 7.464844-19.800781 16-33.433593zm0 0,m328 87.789062c17.671875 0 32-14.328124 32-32 0-14.992187-21.167969-46.402343-25.414062-52.546874-1.574219-2.042969-4.007813-3.242188-6.585938-3.242188s-5.011719 1.199219-6.585938 3.242188c-4.246093 6.144531-25.414062 37.554687-25.414062 52.546874 0 17.671876 14.328125 32 32 32zm0-65.433593c8.535156 13.601562 16 28.128906 16 33.433593 0 8.835938-7.164062 16-16 16s-16-7.164062-16-16c0-5.296874 7.464844-19.800781 16-33.433593zm0 0,m152 87.789062c17.671875 0 32-14.328124 32-32 0-14.992187-21.167969-46.402343-25.414062-52.546874-1.574219-2.042969-4.007813-3.242188-6.585938-3.242188s-5.011719 1.199219-6.585938 3.242188c-4.246093 6.144531-25.414062 37.554687-25.414062 52.546874 0 17.671876 14.328125 32 32 32zm0-65.433593c8.535156 13.601562 16 28.128906 16 33.433593 0 8.835938-7.164062 16-16 16s-16-7.164062-16-16c0-5.296874 7.464844-19.800781 16-33.433593zm0 0" {...object.props} onTransformEnd={this.handleTransform} />*/}
          <SvgSticker name={object.id} props={object.props} draggable={true} onTransformEnd={this.handleTransform} object={object} onDragEnd={this.handleStickerMoveHOC(object.id)} />
        </CanvasLayer>
      );
    }

    return (
      <CanvasLayer key={object.id} id={object.id} type="sticker" object={object}>
        <CachedImage name={object.id} src={object.src} props={object.props} draggable={true} onTransformEnd={this.handleTransform} onDragEnd={this.handleMoveHOC(object.id)} />
      </CanvasLayer>
    );
  }

  renderGroup(object) {
    return (
      <CanvasLayer key={object.id} id={object.id} type="group" onDragEnd={this.handleMoveHOC(object.id)} object={object}>
        {object.index.map(id => {
          const child = object.objects[id];
          switch (child.type) {
            case 'text':
              if (child.props.data) {
                return (<TextPath name={child.id} {...child.props} onTransformEnd={this.handleTransform} />);
              } else {
                return (<Text name={child.id} {...child.props} onTransformEnd={this.handleTransform} />);
              }
            case 'image':
              return (<CachedImage name={object.id} src={object.src} props={object.props} onTransformEnd={this.handleTransform} />);
            default:
              return null;
          }
        })}
      </CanvasLayer>
    );
  }
  showBoundingBox(ids) {
    const stage = this.groupTransformer.getStage();

    this.groupTransformer.attachTo(this.group);

    _forEach(ids, v => {
      const target = stage.findOne(node => {
        return node.name() === (v);
      });

      this.group.add(target);
    });

    this.groupTransformer.forceUpdate();
    this.groupTransformer.getLayer().batchDraw();
  }

  hideBoundingBox() {
    if (!this.groupTransformer) {
      return;
    }

    const stage = this.groupTransformer.getStage();

    const children = this.group.getChildren();

    _forEach(children, child => {
      if (child) {
        const group = stage.findOne(node => {
          return node.name() === (child.name() + '-group');
        });

        group.add(child);
      }
    });

    this.groupTransformer.detach(this.group);
    this.groupTransformer.getLayer().batchDraw();
  }

  updateObjectSizes() {
    const stage = this.groupTransformer.getStage();
    const surfaceId = this.props.objects.present.currentSurface.surface.id;
    const index = this.props.objects.present.index[surfaceId];
    const sizes = {};
    _forEach(index, id => {
      const target = stage.findOne(node => {
        return node.name() === id;
      });

      const scale = target.scale();

      sizes[id] = {
        width: target.getWidth() * scale.x,
        height: target.getHeight() * scale.y
      };
    });

    this.props.updateObjectSizes(sizes);
  }
}

TemplateFreeLayoutStage = connect(f => f, {deselectObjects, transformObject, moveObject, deleteObject, updateObjectSizes, closeTour}, null, {forwardRef: true, withRef: true})(TemplateFreeLayoutStage);

class TemplateFreeLayout extends Component {
  cdRef = null;
  groupTransformer = null;
  group = null;
  stageRef = null;
  scrollRef = null;

  state = {

  }

  constructor(props) {
    super(props);
    this.handleBack = this.handleBack.bind(this);
    this.renderCheckoutButton = this.renderCheckoutButton.bind(this);
    this.handleCopy = this.handleCopy.bind(this);
    this.handleCheckout = this.handleCheckout.bind(this);
    this.handleSelectText = this.handleSelectText.bind(this);
    this.handleSelectImage = this.handleSelectImage.bind(this);
    this.handleDeleteKeyDown = this.handleDeleteKeyDown.bind(this);
  }

  UNSAFE_componentWillMount() {
    this.uppy = new Uppy({
      restrictions: {  },
      autoProceed: true
    });

    this.uppy.use(XHRUpload, {
      endpoint: window.tProjectGlobals.baseUrl + '/designer/upload',
      method: 'post',
      formData: true,
      fieldName: 'files'
    });

    this.uppy.on('upload', () => {
      this.props.toggleLoading(true);
      this.props.closeTour(6);
    })

    this.uppy.on('upload-success', (file, {body}) => {
      //console.log(file, body);
      this.props.addNewImage({
        src: body.url,
        width: body.width,
        height: body.height,
        name: body.name
      });
      this.uppy.removeFile(file.id);
    });
  }

  UNSAFE_componentWillReceiveProps(nextProps, nextContext) {
    if (nextProps.meishi.extraItems.length !== this.props.meishi.extraItems.length) {
      this.scrollRef.scrollTop = 0;
    }
  }

  handleBack(e) {
    e.preventDefault();
    if (window.confirm('前のステップに戻ると現在の編集が破棄されますがよろしいですか？')) {
      this.props.setPhase(2);
    }
  }

  handleCopy(e) {
    console.log(e);
  }

  handleSelectText() {
    //this.props.selectPane('text');
    this.props.addFaceExtraItem(uuidv4(), 'text');
    this.props.closeTour(6);
  }

  handleSelectImage() {
    //this.props.selectPane('image');
    this.props.addFaceExtraItem(uuidv4(), 'image');
  }

  handleCheckout() {
    console.log(this.stageRef);
    this.props.showCopyrightModal(this.stageRef.wrappedInstance.sizeRef);
  }

  handleDeleteKeyDown(e) {
    e.preventDefault();
    if (this.props.layers.selected.length > 0) {
      this.props.deleteObject(this.props.layers.selected);
    }
    e.stopPropagation();
    return false;
  }

  render() {
    const template = this.props.meishi.layouts[this.props.meishi.currentLayout];
    const surfaceId = this.props.objects.present.currentSurface.surface.id;
    const objects = this.props.objects.present.objects[surfaceId];
    const index = this.props.objects.present.index[surfaceId];
    const images = _filter(index, (id) => {
      return objects[id].type === 'image';
    });

    return (
      <div className="t-content t-face-container">
        <div className="t-content-left">
          <div className="t-container-sidebar">
            <div className="t-container-sidebar-pane-top">
              <div className="phase-title">
                <small>STEP5</small>
                <span>自由編集</span>
              </div>
            </div>
            {/*<div className="t-container-sidebar-pane t-container-sidebar-pane-top">*/}

            {/*  <div className="t-container-sidebar-tabs">*/}
            {/*    <button onClick={this.handleSelectText}>*/}
            {/*      <img src={window.tProjectGlobals.assetBaseUrl + "img/tab-text-icon.png"} alt=""/>*/}
            {/*      <span className="t-container-sidebar-tabs-text">テキスト追加</span>*/}
            {/*    </button>*/}
            {/*    <button className={this.props.sidebar.selected === 'image' ? 'active' : ''} onClick={this.handleSelectImage}>*/}
            {/*      <img src={window.tProjectGlobals.assetBaseUrl + "img/tab-image-icon.png"} alt=""/>*/}
            {/*      <span className="t-container-sidebar-tabs-image">ロゴ追加</span>*/}
            {/*    </button>*/}

            {/*  </div>*/}
            {/*</div>*/}
            <div className="t-container-sidebar-pane t-container-sidebar-pane-bottom">
              <div className="t-container-sidebar-content">
                <h3>テキストの追加</h3>
                <button onClick={this.handleSelectText} className="btn btn-info btn-block"><i className="fa fa-plus"/> テキストを追加する</button>
              </div>
              <div className="t-container-sidebar-content t-tutorial-target-1">
                <h3>ロゴや画像の追加</h3>

                <div className="t-container-sidebar-uppy">
                  <div className="t-container-sidebar-uppy-inside">
                    <DragDrop uppy={this.uppy} note="対応形式: JPEG, PNG, GIF, AI, PSD, SVG" locale={{
                      strings: {
                        dropHereOr: '画面に画像をドロップするか、%{browse}してください。',
                        // Used as the label for the link that opens the system file selection dialog.
                        browse: 'ファイルから選択'
                      }
                    }} />
                  </div>
                </div>
              </div>
              <div className="t-container-sidebar-content">
                <div className="t-container-sticker-list">
                  {images.map((id) => {
                    const image = objects[id];
                    return (
                      <span className="t-container-sticker-cell-wrapper">
                        <span
                          key={image.id}
                          className="t-container-sticker-cell square"
                          style={{backgroundImage: 'url(' + image.src + ')'}}
                          onClick={() => {
                            this.props.selectObject(image, {});
                          }}
                        />
                        <button onClick={() => {
                          this.props.deleteObject([id]);
                        }}>削除する</button>
                      </span>

                    );
                  })}
                </div>

                <div className="t-tutorial">
                  <div className="t-tutorial-arrow" />
                  上のボタンでテキストやロゴ、画像の追加ができます。
                  {this.props.meishi.tour[6] && (
                    <CurvedArrow className="arrow-blink" fromSelector=".t-tutorial-arrow" toSelector=".t-tutorial-target-1" color="#1991EB" zIndex={1000} dynamicUpdate={true} fromOffsetY={10} />
                  )}
                </div>

                <div className="t-tutorial">
                  <div className="t-tutorial-arrow-2" />
                  テキストの位置やサイズを変更できます。変更したいテキストを選択して編集しましょう。
                  {this.props.meishi.tour[6] && (
                    <CurvedArrow className="arrow-blink" fromSelector=".t-tutorial-arrow-2" toSelector=".konvajs-content" color="#1991EB" zIndex={1000} dynamicUpdate={true} fromOffsetX={95} />
                  )}
                </div>
              </div>

            </div>
          </div>
        </div>

        <div className="t-content-right t-content-right-flex">
          <div className="t-container-canvas">
            <div className="t-content-right-toolbar">
              <div className="actions">
                <Button onClick={this.handleBack}>前へ: テキストの入力</Button>
                {this.renderCheckoutButton()}
              </div>
              <div>自由にレイアウトを調整してください</div>
            </div>
            <div className="t-face-text-template">
              <div className="t-face-text-preview">
                <ContainerDimensions>
                  <TemplateFreeLayoutStage ref={ref => { this.stageRef = ref; }}/>
                </ContainerDimensions>
              </div>
              <div ref={ref => {this.scrollRef = ref;}} className="t-face-text-form">
                {this.props.meishi.extraItems.map((item, i) => {
                  if (item.type === 'text') {
                    return (
                      <div key={item.id} className="form-group">
                        <label>追加テキスト{(i + 1)}</label>
                        <input type="text" className="form-control" onChange={(e) => {
                          this.props.setExtraTextValue(item.id, e.target.value);
                          this.props.editObject(item.id, {
                            text: e.target.value
                          })
                          // this.setState({
                          //   [object.id]: e.target.value
                          // })
                        }} value={item.props.text || ''} placeholder="テキストを入力してください"/>
                        <ChoiceWidget
                          choices={this.props.fonts.fonts}
                          data={item.font}
                          onSelect={(font) => {
                            this.props.setExtraTextFont(item.id, font);
                            this.props.editObject(item.id, {
                              fontFamily: font.value
                            });
                          }}
                          groupBy="lang"
                          renderLabel={(value) => {
                            return <span style={{fontFamily: value.value}}>{value.label}</span>;
                          }}
                          renderChoice={(value) => {
                            return <span style={{fontFamily: value.value}}>{value.label}</span>;
                          }}
                          renderHeader={(key) => {
                            return <span>{this.props.fonts.languages[key]}</span>;
                          }}
                        />
                        <SimpleColorPicker value={item.props.fill} name={"cp-" + item.id} onChange={(color) => {
                          this.props.setExtraTextColor(item.id, color.hex);
                          this.props.editObject(item.id, {
                            fill: color.hex
                          });
                        }} iconOnly/>
                        {/*<div className="btn btn-secondary" onClick={() => {*/}
                        {/*  this.props.setExtraTextSize(item.id, item.props.fontSize - 1);*/}
                        {/*  this.props.editObject(item.id, {*/}
                        {/*    fontSize: item.props.fontSize - 1*/}
                        {/*  });*/}
                        {/*}}>小さく</div>*/}
                        {/*<div className="btn btn-secondary" onClick={() => {*/}
                        {/*  this.props.setExtraTextSize(item.id, item.props.fontSize + 1);*/}
                        {/*  this.props.editObject(item.id, {*/}
                        {/*    fontSize: item.props.fontSize + 1*/}
                        {/*  });*/}
                        {/*}}>大きく</div>*/}
                      </div>
                    );
                  }

                })}
                {template.objects.map((object, i) => {
                  const font = this.props.meishi.textFonts[object.id] || this.props.fonts.fonts[0];
                  const color = this.props.meishi.textColors[object.id] || '#000000';

                  return (
                    <div key={i} className="form-group">
                      <label>{object.label}</label>
                      <input type="text" className="form-control" onChange={(e) => {
                        this.props.setTextValue(object.id, e.target.value);
                        this.props.editObject(object.id, {
                          text: e.target.value
                        })
                        // this.setState({
                        //   [object.id]: e.target.value
                        // })
                      }} value={this.props.meishi.textValues[object.id] || ''}/>
                      <ChoiceWidget
                        choices={this.props.fonts.fonts}
                        data={font}
                        onSelect={(font) => {
                          this.props.setTextFont(object.id, font);
                          this.props.editObject(object.id, {
                            fontFamily: font.value
                          });
                        }}
                        groupBy="lang"
                        renderLabel={(value) => {
                          return <span style={{fontFamily: value.value}}>{value.label}</span>;
                        }}
                        renderChoice={(value) => {
                          return <span style={{fontFamily: value.value}}>{value.label}</span>;
                        }}
                        renderHeader={(key) => {
                          return <span>{this.props.fonts.languages[key]}</span>;
                        }}
                      />
                      <SimpleColorPicker value={color} name={"cp-" + i} onChange={(color) => {
                        this.props.setTextColor(object.id, color.hex);
                        this.props.editObject(object.id, {
                          fill: color.hex
                        });
                      }} iconOnly/>
                      {/*<div className="btn btn-secondary" onClick={() => {*/}
                      {/*  this.props.setTextSize(object.id, object.fontSize - 1);*/}
                      {/*  this.props.editObject(object.id, {*/}
                      {/*    fontSize: object.fontSize - 1*/}
                      {/*  });*/}
                      {/*}}>小さく</div>*/}
                      {/*<div className="btn btn-secondary" onClick={() => {*/}
                      {/*  this.props.setTextSize(object.id, object.fontSize + 1);*/}
                      {/*  this.props.editObject(object.id, {*/}
                      {/*    fontSize: object.fontSize + 1*/}
                      {/*  });*/}
                      {/*}}>大きく</div>*/}
                    </div>

                  );
                })}

              </div>

            </div>
          </div>

        </div>
        <KeyHandler keyCode={46} onKeyHandle={this.handleDeleteKeyDown} />
        <KeyHandler keyCode={8} onKeyHandle={this.handleDeleteKeyDown} />
        {/*<Tour*/}
        {/*  steps={*/}
        {/*    [*/}
        {/*      {*/}
        {/*        selector: '.t-canvas-container-inside',*/}
        {/*        content: 'ここではレイアウトを自由に編集できます',*/}
        {/*      },*/}
        {/*      {*/}
        {/*        selector: '.t-container-sidebar-tabs',*/}
        {/*        content: '別のテキストやロゴを追加することが出来ます',*/}
        {/*      }*/}
        {/*    ]*/}
        {/*  }*/}
        {/*  isOpen={this.props.meishi.tour[5]}*/}
        {/*  onRequestClose={() => { this.props.closeTour(5) }}*/}
        {/*  showNumber={false}*/}
        {/*/>*/}
      </div>
    );
  }

  renderCheckoutButton() {
    if (this.props.products.totalAmount === 0 || (this.props.objects.present.collision || []).length !== 0) {
      return (
        <button className="btn btn-success btn-lg" data-tip="数量を選択してください" data-type="warning" data-place="bottom">
          {this.props.system.checkoutLabel}
        </button>
      );
    }

    return (
      <button className="btn btn-success" onClick={this.handleCheckout} disabled={this.props.meishi.phase < 3}>
        {this.props.system.checkoutLabel}
      </button>
    );
  }

}

export default connect(f => f, {
  setPhase, setFaceObjects, closeTour, setTextValue, setTextFont, setTextColor, showCopyrightModal, editObject,
  setExtraTextValue, setExtraTextFont, setExtraTextColor, addFaceExtraItem, toggleLoading, addNewImage,
  setTextSize, setExtraTextSize, deleteObject, selectObject
})(TemplateFreeLayout);



// WEBPACK FOOTER //
// ./src/components/Face/TemplateFreeLayout.js